import { Chain } from "wagmi";

export const bscChain: Chain = {
  id: 56,
  name: "Binance Smart Chain",
  network: "bsc",
  nativeCurrency: {
    decimals: 18,
    name: "Binance",
    symbol: "BNB",
  },
  rpcUrls: {
    default:
      "https://bsc-mainnet.nodereal.io/v1/8438d9c512534d20a2367b930e8863e3",
  },
  blockExplorers: {
    default: { name: "BSCscan", url: "https://bscscan.com" },
  },
  testnet: false,
};

export const bscChainTestnet: Chain = {
  id: 97,
  name: "Binance Smart Chain - Testnet",
  network: "bsc-testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Binance",
    symbol: "BNB",
  },
  rpcUrls: {
    default: "https://data-seed-prebsc-1-s1.binance.org:8545",
  },
  blockExplorers: {
    default: {
      name: "BSCscan",
      url: "https://testnet.bscscan.com",
    },
  },
  testnet: true,
};

export const chainConfig =
  process.env.NEXT_PUBLIC_NETWORK == "mainnet" ? bscChain : bscChainTestnet;
